import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { EgitimKaydiEditComponent } from './egitim-kaydi-edit.component';
import { EgitimKaydiKartComponent } from './egitim-kaydi-kart.component';

@DinamikBilesen({
  id: 'egitim-kaydi',
  baslik: 'Eğitim Kaydı',
  aciklama: 'Eğitim kaydı ekle',
  ikon: 'read',
  kategori: 'personel',
})
class EgitimKaydi {
  paylas_kutusu = EgitimKaydiEditComponent;
  paylasilmis_kart = EgitimKaydiKartComponent;
}
